import React from 'react';
import { Card, CardBody } from '@heroui/react';

interface FinanceStatCardProps {
  type: string;
  dateRange: string;
  amount: string;
}

const FinanceStatCard: React.FC<FinanceStatCardProps> = ({ type, dateRange, amount }) => {
  return (
    <Card className="border border-[#E4E4E7] shadow-sm rounded-[14px]">
      <CardBody className="p-[16px]">
        <div className="flex flex-col gap-[16px]">
          {/* Header */}
          <div className="flex gap-[4px] h-[20px] items-center">
            <p className="font-medium text-[14px] leading-[18px] text-[#71717A]">
              {type}
            </p>
            <div className="bg-[#F4F4F5] px-[6px] py-0 rounded-[12px]">
              <p className="font-medium text-[12px] leading-[18px] text-[#71717A]">
                {dateRange}
              </p>
            </div>
          </div>

          {/* Amount */}
          <div className="flex gap-[8px] items-end">
            <p className="font-semibold text-[24px] leading-[normal] text-[#3F3F46]">
              {amount}
            </p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default FinanceStatCard;
